
import { Options, prop, Vue } from "vue-class-component";
import ChargeableWeightSummaryV4 from "./components/weight-cost.vue";
import {
  ChargeableWeightBreakdownV4,
  ProtectionPackingBookingV4
} from "@/domain/entities/BookingV4";

class Props {
  chargeableWeightKg = prop<number>({ required: true, type: Number });
  totalKoli = prop<number>({ required: true, type: Number });
  chargeableWeightExpanded = prop<boolean>({ required: true, type: Boolean });
  chargeableWeightBreakdown = prop<ChargeableWeightBreakdownV4>({
    required: true,
    type: ChargeableWeightBreakdownV4
  });
  woodpacking = prop<boolean>({ required: true, type: Boolean });
  numericLocale = prop<string>({ default: "" });
  isReverseJourney = prop<boolean>({ required: false, type: Boolean });
}

@Options({
  name: "BookingStickyFooterV4",
  emits: ["update:protectionPacking", "update:chargeableWeightExpanded"],
  components: { ChargeableWeightSummaryV4 }
})
class BookingStickyFooterV4 extends Vue.with(Props) {
  onUpdateProtectionPacking(value: ProtectionPackingBookingV4) {
    this.$emit("update:protectionPacking", value);
  }

  get chargeableWeightExpandedModelValue(): boolean {
    return this.chargeableWeightExpanded;
  }

  set chargeableWeightExpandedModelValue(value: boolean) {
    this.$emit("update:chargeableWeightExpanded", value);
  }
}

export default BookingStickyFooterV4;
